import { useEffect, useState } from 'react';
import './dropdown.css';

interface DropdownProps {
  items: { text: string; value: any }[];
  onSelect: (value: any) => void;
  initialValue?: any;
  editable?: boolean;
  style?: React.CSSProperties;
  label?: string;
  disableSelect?: boolean;
}

function DropDownInput({
  items,
  onSelect,
  initialValue,
  editable = false,
  style,
  label = 'Статус',
  disableSelect = false,
}: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ text: string; value: any } | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (item: { text: string; value: any }) => {
    if (item.value === 'completed' && disableSelect) return;
    setSelectedItem(item);
    setIsOpen(false);
    onSelect(item.value);
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      const foundItem = items.find((item) => item.value === initialValue);
      if (foundItem) {
        setSelectedItem(foundItem);
      } else {
        setSelectedItem(null);
      }
    }
  }, [initialValue, items]);

  return (
    <div className="dropdown input__container" style={{ ...style, ...(editable ? {} : { pointerEvents: 'none' }) }}>
      <label className="input__label">{label}</label>
      <div
        className={'input__field ' + (editable ? 'active' : '')}
        onClick={() => {
          if (editable) {
            toggleDropdown();
          }
        }}
      >
        {selectedItem ? selectedItem.text : 'Выберите элемент'}
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          {items.map((item, index) => {
            const isDisabled = item.value === 'completed' && disableSelect;

            return (
              <li
                key={index}
                className={`dropdown-item ${isDisabled ? 'disabled' : ''}`}
                onClick={() => handleSelect(item)}
              >
                {item.text}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default DropDownInput;
